import axiosClient from 'axiosClient';
import { axiosHyperwolfClient } from 'axiosClient';
import axiosClientDistribution from "axiosClient/indexDistribution";
import axiosClientHyperWolf from 'axiosClient/indexHyperWolf';
import axiosClientStilo from 'axiosClient/indexStilo';
import { getQueryString } from 'utilities/common';
import { STILO } from 'utilities/constants';
import { HEMP, HYPERWOLF } from 'utilities/constants';
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function uploadImageAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post('/api/v1/upload/image', data);
}

export async function uploadProductImageAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post('api/v1/upload/product/image', data);
}

export async function fetchInfoEffectsAPI() {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get('/api/v1/product/infoeffects');
}

export async function fetchProductCategoriesAPI(filters) {
    if (adminsMode === HYPERWOLF) {
        return await axiosClientHyperWolf.get(`/api/v1/admin/category/sub/list?${getQueryString(filters)}`)
    }
    else
        return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/category/get?${getQueryString(filters)}`);
}

export async function fetchAllRegionsAPI() {
    return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/region/get`);
}

export async function BulkProductUpdateAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/product/bulk/update`, data);
}

export async function getSignupStatusAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : adminsMode === HYPERWOLF ? axiosClientHyperWolf : axiosClient).get(`/api/v1/signup/status`, data);
}

export async function fetchRefundStatusAPI(data) {
    return await axiosClient.get(`/api/v1/refund/order/value`);
}

export async function updateRefundDataAPI(data) {
    return await axiosClient.post(`/api/v1/refund/order/value`, data);
}

export async function updateSignupStatusAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : adminsMode === HYPERWOLF ? axiosClientHyperWolf : axiosClient).post(`/api/v1/signup/status/update`, data);
}


export async function getPaymentPlatformStatusAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/payment/status`, data);
}



export async function getProductDisclaimersAPI() {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).get('/api/v1/product/disclaimer');
}


export async function updateDisclaimerAPI(data) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).post('/api/v1/update/product/disclaimer', data);
}

export async function updatePaymentPlatformStatusAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : adminsMode === HEMP ? axiosClient : axiosHyperwolfClient).post(`/api/v1/payment/status/update`, data);
}

export async function fetchRefundListAPI(data) {
    return await axiosClient.get(`api/v1/order/refund/reasons/list
`);
}
export async function fetchRefundTableAPI(data) {
    return await axiosClient.get(`api/v1/order/refund/reason
`);
}

export async function addCommonReasonAPI(data) {
    return await axiosClient.post(`api/v1/order/refund/reason`, data);
}

export async function editRefundReasonApi(data, reasonId) {
    return await axiosClient.put(`api/v1/order/refund/reason/${reasonId}`, data);
}

export async function deleteReasonApi(reasonId) {
    return await axiosClient.delete(`api/v1/order/refund/reason/${reasonId}`);
}

export async function getLegalListAPI(data) {
    return await axiosClient.get(`/api/v1/legal/listing?${getQueryString(data)}&userType=admin`);
}

export async function deleteLegalAPI(slug, platform) {
    return await axiosClient.delete(`/api/v1/delete/legal?platform=${platform}&id=${slug}`);
}

export async function getStaticLegalAPI(id, platform) {
    return await axiosClient.get(`/api/v1/legal?platform=${platform}&userType=admin&id=${id}`);

}

export async function getReorderDragAPI(data) {
    return await axiosClient.post(`/api/v1/admin/seo/sections/reorder`, data);
}

export async function IsheadingExistAPI({ platform, heading }) {
    return await axiosClient.get(`api/v1/admin/seo/check/page/status?platform=${platform}&heading=${heading}`);
}

export async function IsheadingExistBlogAPI({ platform, heading ,strain}) {
    if(strain){
        return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/strain/check/page?strainName=${heading}`);

    }else{
        return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/blogs/check/page?title=${heading}`);

    }
}

export async function createStaticPageAPI(data) {
    return await axiosClient.post(`/api/v1/admin/seo`, data);
}

export async function updateStaticPageAPI(data, id, platform) {
    return await axiosClient.put(`/api/v1/update/legal?platform=${platform}&id=${id}`, data);
}

export async function updateBlockReasonAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`api/v1/member/create/block/reason`, data);
}

export async function getBlockReasonAPI() {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get('api/v1/member/block/reason');
}

export async function fetchWalletTableAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/member/wallet/adjust/reason
`);
}

export async function editWalletReasonApi(data, reasonId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`api/v1/member/wallet/adjust/reason/${reasonId}`, data);
}

export async function addWalletReasonAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`api/v1/member/wallet/adjust/reason`, data);
}

export async function deleteWalletReasonApi(reasonId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`api/v1/member/wallet/adjust/reason/${reasonId}`);
}

export async function fetchWalletReasonListAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/member/wallet/adjust/reason/list`);
}


export async function BulkProductCategoriesUpdateApi(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/admin/category/bulk/update`, data);
}

export async function uploadFile(data, config) {
    return await axiosClientDistribution.post(`/api/v1/upload/image`, data, config);
}
export async function fetchAIPromptAPI(data) {
    return await axiosClientStilo.post(`/api/v1/generate/description`, data);
}


export async function getMediaFromLibraryApi(data) {
    return await axiosClient.get(`api/v1/image/library`);
}

export async function getBlazeStatusApi() {
    return await axiosClientHyperWolf.get(`api/v1/blaze/status`);
}


export async function updateBlazeStatusApi(data) {
    return await axiosClientHyperWolf.post(`api/v1/blaze/status/update`, data);
}
export async function getHomePageListAPI(data) {
    return await axiosClientHyperWolf.get(`/api/v1/admin/home/page?${getQueryString(data)}&userType=admin`);
}



export async function getHomePageEditDataAPI(id, isHomePage) {
    if (isHomePage) {
        return await axiosClientHyperWolf.get(`/api/v1/admin/home/page/default`);
    }
    return await axiosClientHyperWolf.get(`/api/v1/admin/home/page/${id}`);
}


export async function addProductCarouselApi(data, CarouselId) {
    if (CarouselId) {
        return await axiosClientHyperWolf.put(`/api/v1/product/carousel/${CarouselId}`, data);
    }
    else {

        return await axiosClientHyperWolf.post(`/api/v1/product/carousel`, data);
    }
}


export async function fetchCarouselIdProductApi(data) {
    return await axiosClientHyperWolf.get(`/api/v1/product/carousel/${data?.CarouselId}/products?${getQueryString(data)}`);
}

export async function assignProductsToCarouselApi(carouselId, data) {
    return await axiosClientHyperWolf.post(`/api/v1/product/carousel/${carouselId}/assignment`, data);
}

export async function fetchProductDeatilsCarouselApi(data) {
    return await axiosClientHyperWolf.get(`/api/v1/product/carousel/single/${data}`);
}
